import React, { useCallback } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";

import { Typography } from "antd";

import styles from "components/PlatformLayout/components/PlatformPageHeader/PlatformPageHeader.module.less";

const { Title } = Typography;

const SellerDashboardBreadCrumbs = () => {
  const history = useHistory();

  const eventsAndUpdatesPage = !!useRouteMatch("/dashboard/events-and-promos");
  const powurUpdatesPage = !!useRouteMatch("/dashboard/powur-updates");

  const breadcrumb = useCallback(() => {
    if (eventsAndUpdatesPage) {
      return "Events & Promos";
    }
    if (powurUpdatesPage) {
      return "Powur Updates";
    }

    return null;
  }, [eventsAndUpdatesPage, powurUpdatesPage]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleBaseNavigate = () => {
    history.push("/dashboard");
  };

  const baseStyle = {
    cursor: "pointer",
    textTransform: "capitalize",
    fontWeight: 600,
  };

  return (
    <>
      <Title className={styles.title} style={baseStyle} onClick={handleBaseNavigate}>
        Dashboard
      </Title>
      {breadcrumb() && (
        <>
          <span className={styles.titleSeparator}>/</span>
          <Title className={styles.titleSecondary}>{breadcrumb()}</Title>
        </>
      )}
    </>
  );
};

export default SellerDashboardBreadCrumbs;
